import React, { useEffect } from 'react';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';

import { MenuContextProvider } from '../../MyContexts/Rest_Context';
import UsersPage from './UsersPage';

const UsersListP = (props) => {
 
    useEffect(() => {

      ///  myFunctions.connCheck();

    }, [])
    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">

            <TheMasterContextProvider>
                <Sidenavigation1 />
                <main className="body-content">
                    <MenuContextProvider>
                        <Topnavigation />
                        <UsersPage />
                    </MenuContextProvider>
                </main>
                {/* <Quickbar /> */}
            </TheMasterContextProvider>

        </div>
    );
}

export default UsersListP;